import fetch from '../../../api/fetch';
import { REDUX_ACTIONS } from '../../../shared/config/constants';
import { parseError } from '../../../utils/fetchErrorParser';
import { enqueueSnackbar } from '../snackbar';

export const listEpicorOrderDetails = (params) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.EPICOR_ORDER_DETAILS_LOADING,
  });

  const body = {
    type: 'GET',
    url: '/orderDetails',
    params: {
      filter: `OrderNum eq ${params.orderNumValue}`,
    },
  };

  return fetch
    .post('epicorProxy', body)
    .then((resp) => {
      if (!resp.ok) {
        return Promise.reject(resp);
      }
      return resp.json();
    })
    .then((data) => {
      dispatch({
        type: REDUX_ACTIONS.EPICOR_ORDER_DETAILS_SUCCESS,
        payload: {
          epicorOrderDetails: data.data,
          paginatedElements: data.data.length,
        },
      });
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);

      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );

      dispatch({
        type: REDUX_ACTIONS.EPICOR_ORDER_DETAILS_ERROR,
        payload: { ...error, message: errorMessage },
      });
    });
};
